/**
 * Login slice (RTK). Keeps same state shape as reducer-Login for drop-in replacement.
 * Handles legacy action types (GET_USER_INFO, etc.) so existing loginActions.js
 * keep working without changes.
 */
import { createSlice } from "@reduxjs/toolkit";
import { REFRESH_TOKEN_ACTION } from "../../constants/metaData";
import { getPayloadValue } from "../../../functions/reduxMethod";

const defaultTokenRefreshPreAction = {
  retry: 0,
  actionType: REFRESH_TOKEN_ACTION.none,
};

const initialState = {
  "@odata.context": null,
  value: [],
  userInfo: [],
  tokenInfo: [],
  teamsContext: [],
  tokenRefreshPreAction: defaultTokenRefreshPreAction,
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setUserInfo(state, { payload }) {
      state.userInfo = payload;
    },
    setTokenInfo(state, { payload }) {
      state.tokenInfo = payload;
    },
    setTeamsContext(state, { payload }) {
      state.teamsContext = payload;
    },
    setTokenRefreshPreAction(state, { payload }) {
      state.tokenRefreshPreAction = getPayloadValue(
        payload,
        defaultTokenRefreshPreAction
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase("GET_USER_INFO", (state, action) => {
        state.userInfo = action.payload;
      })
      .addCase("GET_TOKEN_INFO", (state, action) => {
        state.tokenInfo = action.payload;
      })
      .addCase("GET_TEAMS_CONTEXT", (state, action) => {
        state.teamsContext = action.payload;
      })
      .addCase("ON_LOGIN_REFRESH_PREACTION", (state, action) => {
        state.tokenRefreshPreAction = getPayloadValue(
          action.payload,
          defaultTokenRefreshPreAction
        );
      });
  },
});

export const {
  setUserInfo,
  setTokenInfo,
  setTeamsContext,
  setTokenRefreshPreAction,
} = loginSlice.actions;

export default loginSlice;
